import React, { useEffect, useState } from 'react';
import { Box, FormControl, IconButton, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from "moment";

import { MobileButton } from "../../../components";

import { arrayOfNumbers } from "../../../services/util.service";

import useStyles from "./Page4.style";

const AdoptionQuestionnaire = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const currentYear = new Date(Date.now()).getFullYear();
    const dateOfBirth = localStorage.getItem('dateOfBirth') || props.dateOfBirth;
    const legalAdoptionPermissionYear = moment(dateOfBirth).add(18, 'years').year();

    return (
        <>
            <Box className={classes.adoptionQuestionnaire}>
                <Box className={classes.adoptionQuestionnaireHeader}>
                    <span>{t('common.substantive.adoption')} #{props.index + 1}</span>
                    <IconButton aria-label="delete" color="inherit" onClick={props.onAdoptionRemove}>
                        <DeleteIcon />
                    </IconButton>
                </Box>
                <Box className={classes.adoptionQuestionnaireBody}>
                    <Box className={classes.adoptionQuestionaireQuestionSet}>
                        <Box className={classes.adoptionQuestionnaireQuestion}>
                            {t('repliQuestionnaire.general.pregnancyYear')}
                        </Box>
                        <FormControl variant="outlined" fullWidth>
                            <Select value={props.data.year} onChange={props.onYearChange}>
                                <MenuItem key={0} value={0}></MenuItem>
                                {arrayOfNumbers(legalAdoptionPermissionYear, currentYear - legalAdoptionPermissionYear + 1)
                                    .map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </Box>
                    <Box className={classes.adoptionQuestionaireQuestionSet}>
                        <Box className={classes.adoptionQuestionnaireQuestion}>
                            {t('repliQuestionnaire.general.adoptedQuantityQuestion')}
                        </Box>
                        <TextField
                            value={props.data.childrenQty}
                            onChange={props.onChildrenQtyChange}
                            variant="outlined"
                            type="number"
                        />
                    </Box>
                </Box>
            </Box>
        </>
    );
};

const Page4 = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [adoptionData, setAdoptionData] = useState([]);

    useEffect(() => {
        const localStorageAdoptionData = localStorage.getItem('adoptions') && JSON.parse(localStorage.getItem('adoptions'));
        const propsAdoptionData = props.profile && props.profile.adoptions;
        const storedAdoptionData = localStorageAdoptionData || propsAdoptionData;

        if (storedAdoptionData) setAdoptionData(storedAdoptionData);
    }, [props.profile]);

    const handleAddAdoption = e => {
        let newArray = [...adoptionData, {
            year: '',
            childrenQty: ''
        }];
        setAdoptionData(newArray);
        localStorage.setItem('adoptions', JSON.stringify(newArray));
    };

    const handleRemoveAdoption = index => e => {
        let remainingData = [...adoptionData];
        remainingData.splice(index, 1)
        setAdoptionData(remainingData);
        localStorage.setItem('adoptions', JSON.stringify(remainingData));
    };

    const handleAdoptionDataChange = (index, field) => e => {
        let modifiedData = adoptionData.map(
            (data, i) => {
                if (i === index) data[field] = e.target.value;
                return data;
            }
        );
        setAdoptionData(modifiedData);
        localStorage.setItem('adoptions', JSON.stringify(modifiedData));
    };

    return (
        <>
            <Box className={classes.textSection}>
                <Typography component="div" className={classes.text}>
                    {t('repliQuestionnaire.general.adoptionsSection')}
                </Typography>
            </Box>
            {
                adoptionData.map((data, i) =>
                    <AdoptionQuestionnaire
                        key={i}
                        index={i}
                        data={data}
                        dateOfBirth={props.profile.dateOfBirth}
                        onAdoptionRemove={handleRemoveAdoption(i)}
                        onAdoptionYearChange={handleAdoptionDataChange(i, 'year')}
                        onChildrenQtyChange={handleAdoptionDataChange(i, 'childrenQty')}
                    />
                )
            }
            <MobileButton
                label={t('repliQuestionnaire.label.addAdoption')}
                startIcon={<AddIcon />}
                onClick={handleAddAdoption}
            />
        </>
    );
};

export default Page4;